import * as React from 'react';

import {ActionMenu} from '../action-menu/action-menu';
import type {SelectMenuOption} from '../action-menu/action-menu';
import {colors} from '../colors/colors';
import {PopoverInfo} from '../popover-info/popover-info';
import {TwoLine} from '../two-line/two-line';

import styles from './legacy-setup-table-wrapper.module.css';

type Props = {
    title: string | React.ReactNode;
    subtitle?: string | React.ReactNode;
    icon?: React.ComponentType<any> | null | undefined;
    children: React.ReactNode;
    actionItem?: React.ReactNode | null | undefined;
    count?: number | null | undefined;
    helpInfo?: string | React.ReactNode;
    actionMenuOptions?: SelectMenuOption[];
    getTableHeaderRef?: (arg1?: HTMLElement | null | undefined) => void;
    fullWidth?: boolean;
};

/**
 * This is used as a wrapper around the react table to make it fit in with the
 * old tables on setup pages.
 */
export function LegacySetupTableWrapper(props: Props) {
    const Icon = props.icon;

    const wrapperClass = props.fullWidth ? 'full-width br-3' : 'br-3';

    return (
        <div className={wrapperClass} ref={props.getTableHeaderRef}>
            <div className={styles['table-header']}>
                <div className={styles['header-left']}>
                    <div className={styles.title}>
                        <TwoLine
                            topRow={
                                <div className='flex align-center'>
                                    <div className={styles.title}>{props.title}</div>
                                    {props.count ? (
                                        <div className={styles.count}>
                                            ({props.count.toLocaleString()})
                                        </div>
                                    ) : undefined}
                                    {props.helpInfo ? (
                                        <div className={styles['help-button']}>
                                            <PopoverInfo size={16} info={props.helpInfo} />
                                        </div>
                                    ) : undefined}
                                </div>
                            }
                            bottomRow={props.subtitle}
                            icon={
                                Icon
                                    ? () => (
                                          <Icon
                                              size={16}
                                              style={{color: colors.grey}}
                                              alignCenter={true}
                                          />
                                      )
                                    : undefined
                            }
                            shouldCenterSingleLine={true}
                        />
                    </div>
                </div>
                {props.actionMenuOptions ? (
                    <div className={styles['action-menu']}>
                        <ActionMenu options={props.actionMenuOptions} size='small' />
                    </div>
                ) : undefined}
                {props.actionItem && !props.actionMenuOptions ? (
                    <div className={styles['action-menu']}>{props.actionItem}</div>
                ) : undefined}
            </div>
            {props.children}
        </div>
    );
}
